module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xabdo4-08c8c79e67767ca8bdef7fdf78422593.jpg";